<template>
  <v-container fluid class="pa-0">
    <v-row dense>
      <!-- Search Input-->
      <v-col cols="12">
        <v-text-field
          ref="search"
          label="Organization Lookup"
          v-model="term"
          hint="Enter the organizations name"
          placeholder="Start typing to search"
          persistent-hint
          color="color3"
          append-icon="fas fa-search"
          autocomplete="off"
          type="search"
          :loading="searching"
          solo
          clearable
        ></v-text-field>
      </v-col>
      <!-- Data Table -->
      <v-col cols="12" v-if="!selector">
        <v-data-table
          :headers="headers"
          :items="searchResults"
          class="elevation-1"
          :options.sync="pagination"
          :footer-props="{itemsPerPageOptions: [10, 20, 50, -1]}"
          :loading="searching"
        >
          <template v-slot:[`item.actions`]="{item}">
            <v-btn
              color="color3 color3Text--text"
              small fab
              @click="selectProfile(item)"
            >
              <v-icon>fas fa-caret-right</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
      <!-- Data List -->
      <v-col cols="12" v-else>
        <v-expand-transition>
          <v-list three-line v-if="results">
            <template v-for="(r, i) in searchResults">
              <v-list-item @click.stop="selectProfile(r)" :key="r.id">
                <v-list-item-content>
                  <v-img :src="r.theme.logoUrl" contain width="100%" max-height="90%"></v-img>
                </v-list-item-content>
                <v-list-item-content>
                  <v-list-item-title>{{r.name}}</v-list-item-title>
                  <v-list-item-subtitle>{{r.username}}.volleyballlife.com</v-list-item-subtitle>
                  <v-list-item-subtitle v-if="user && user.vbl">Id: {{r.id}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider :key="`${r.id}-div`" v-if="(i + 1) !== searchResults.length"></v-divider>
            </template>
          </v-list>
        </v-expand-transition>
        <v-expand-transition>
          <div v-if="confirm && firstResult" class="text-center">
            <v-btn color="color3 color3Text--text" @click.stop="selectProfile(firstResult)">Continue with {{firstResult.name}}</v-btn>
          </div>
        </v-expand-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import debounce from 'lodash.debounce'
import { mapGetters } from 'vuex'
export default {
  props: ['active', 'autoSearch', 'selector', 'instructions', 'exclude'],
  data () {
    return {
      searching: false,
      term: null,
      searchResults: [],
      pagination: { itemsPerPage: 10 },
      headers: [
        { text: 'Subdomain', value: 'username', align: 'left' },
        { text: 'Name', value: 'name', align: 'left' },
        { text: 'Email', value: 'email', align: 'left' },
        { text: 'Phone', value: 'phone', align: 'left' },
        { value: 'actions', sortable: false }
      ],
      selectedProfile: null,
      loading: false,
      confirm: false
    }
  },
  computed: {
    ...mapGetters(['subdomain', 'user']),
    results () {
      return this.searchResults.length
    },
    firstResult () {
      return this.searchResults[0]
    }
  },
  methods: {
    reset () {
      this.selectedProfile = null
      this.term = null
      this.searchResults = []
      this.confirm = false
    },
    selectProfile (profile) {
      this.selectedProfile = profile
      this.$emit('profile-selected', profile)
    },
    search: debounce(function () {
      this.doSearch()
    }, 500),
    doSearch () {
      if (!this.term || typeof this.term !== 'string' || this.term.length < 3) {
        this.searchResults = []
        return
      }
      this.selectedProfile = null
      this.searching = true
      this.$VBL.organization.search(this.term)
        .then(r => {
          this.searchResults = this.exclude ? r.data.filter(f => !this.exclude.includes(f.username)) : r.data
          this.tryAutoSelect()
        })
        .catch(e => console.log(e))
        .finally(() => {
          this.searching = false
        })
    },
    tryAutoSelect () {
      if (this.selector && this.searchResults.length === 1) {
        if (this.term.toLowerCase() === this.searchResults[0].username.toLowerCase()) {
          this.selectProfile(this.searchResults[0])
        } else {
          this.confirm = true
        }
      }
    }
  },
  watch: {
    term: 'search',
    active: function (val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.search.$el.focus()
          }, 500)
        })
      } else {
        this.reset()
      }
    }
  },
  mounted () {
    if (this.autoSearch) {
      this.term = this.autoSearch
      this.search()
    }
  },
  components: {
  }
}
</script>
